import { MIN_AMOUNT_SHARE_PAYMENT, minAmountSharePaymentByCountry } from "../configs/SharePaymentConfigs";

export const getMinAmountSharePayment = (country?: string): number => {
    if (!country) {
        return MIN_AMOUNT_SHARE_PAYMENT;
    }

    return minAmountSharePaymentByCountry[country] || MIN_AMOUNT_SHARE_PAYMENT;
}